<template>
    <div class="header">
        <div class="left">
            <router-link class="top-menu" to="/top">
                <span class="btn-sm btn-secondary">値引</span>
            </router-link>
            <!-- <router-link class="top-menu" to="/scan">
                <span class="btn-sm btn-secondary">単品</span>
            </router-link> -->
        </div>
        <div class="center">
            <span>AI値引き</span> <span id="version-no">v{{version}}</span>
        </div>
        <div class="right">
            <router-link class="top-menu" to="/setting">
                <span class="btn-sm btn-secondary">設定</span>
            </router-link>
        </div>
    </div>
</template>

<style scoped>
.header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}
.left {
    text-align: left;
}
.right {
    text-align: right;
}
.top-menu {
    margin: 0 5px;
}
</style>

<script>
import package_json from '../../../package.json'

export default {
    name: 'Header',
    components: {
    },
    data() {
        return {
            name: "test",
            version: package_json.version
        }
    },
    methods: {
    },
}
</script>
